import { Terminal } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const TerminalIcon = DeckardIconWrapper({ Icon: Terminal });
